<template>
  <div class="e_store-container min-h-screen my-10">
    <ArticlesGrid class="mb-5 mt-2" />
  </div>
</template>

<script setup lang="ts">
const { store } = useDomainState()
const { url } = useDomainHost()
const { t } = useI18n()

useServerSeoMeta(
  useOgMeta(url + '/articles', t('articles'), store.value?.about)
)

useHead({
  title: () => t('articles'),
  meta: [
    { hid: 'description', name: 'description', content: store.value?.about }
  ],
  link: [useSeoCanonical(url + '/articles')],
  script: [
    useSeoBreadcrumb([
      useSeoBreadcrumbItem(1, store.value?.name, url),
      useSeoBreadcrumbItem(2, t('articles'), url + '/articles')
    ])
  ]
})
</script>
